import { create } from "zustand";
import { persist } from "zustand/middleware";
import api from "../api/client";

// ─── Auth store ─────────────────────────────────────────────────────────────
export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      isAuthenticated: false,
      login: async (username, password) => {
        const { data } = await api.post("/api/auth/login/", { username, password });
        localStorage.setItem("access_token", data.access);
        localStorage.setItem("refresh_token", data.refresh);
        set({ accessToken: data.access, isAuthenticated: true });
        const me = await api.get("/api/auth/me/");
        set({ user: me.data });
      },
      logout: () => {
        localStorage.clear();
        set({ user: null, accessToken: null, isAuthenticated: false });
      },
    }),
    { name: "auth-store", partialize: (s) => ({ isAuthenticated: s.isAuthenticated }) }
  )
);

// ─── Chat store ──────────────────────────────────────────────────────────────
export const useChatStore = create((set, get) => ({
  conversations: [],
  activeConversationId: null,
  messages: [],

  loadConversations: async () => {
    const { data } = await api.get("/api/conversations/");
    set({ conversations: data.results || data });
  },

  selectConversation: async (convId) => {
    set({ activeConversationId: convId });
    const { data } = await api.get(`/api/conversations/${convId}/messages/`);
    set({ messages: data.results || data });
  },

  addMessage: (msg) => set((s) => ({ messages: [...s.messages, msg] })),

  newConversation: () => {
    const id = crypto.randomUUID();
    set({ activeConversationId: id, messages: [] });
    return id;
  },
}));

// ─── Documents store ─────────────────────────────────────────────────────────
export const useDocumentStore = create((set) => ({
  documents: [],
  pendingPlan: null,  // Document en attente de validation plan

  loadDocuments: async () => {
    const { data } = await api.get("/api/documents/");
    set({ documents: data.results || data });
  },

  uploadDocument: async (file, metadata) => {
    const formData = new FormData();
    formData.append("file", file);
    Object.entries(metadata).forEach(([k, v]) => formData.append(k, v));
    const { data } = await api.post("/api/documents/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    set((s) => ({ documents: [data, ...s.documents] }));
    return data;
  },

  approvePlan: async (docId, plan) => {
    await api.post(`/api/documents/${docId}/approve_plan/`, { plan });
    set({ pendingPlan: null });
  },

  triggerEmbedding: async (docId) => {
    await api.post(`/api/documents/${docId}/trigger_embedding/`);
  },

  triggerGraphing: async (docId) => {
    await api.post(`/api/documents/${docId}/trigger_graphing/`);
  },

  setPendingPlan: (doc) => set({ pendingPlan: doc }),
}));
